import * as types from 'constants/actionTypes'

const initialState = null

export default function (state = initialState, action) {
  switch (action.type) {

    case types.SET_LAST_APP:
      return action.lastApp

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/lastApp.js